export default {
  label: 'Respondidos',
  items: {
    placeholder: 'Todos',
    replied: 'Somente Respondidos',
    unanswered: 'Somente No Respondidos',
  },
};
